import * as PropTypes from "prop-types";

// ITEM -> GROUP
// ITEM -> GROUP -> SECTION -> STEP // not used

export const WIZARD_GROUP_TYPES = {
  group: "group",
  filter: "filter",
  custom: "custom",
  inputs: "inputs",
  contact: "contact",
  appointment: "appointment",
  review: "review",
  success: "success",
}

export const startWizardNode = {
  id: '0',
  type: 'input',
  position: { x: 250, y: 0 },
}

export const defaultWizardItem = {
  id: 0,
  uniqueHashId: "", // is used for clone comparing
  visualizer: "",
  name: "",
  description: "",
  thumbnail: "",
  enabled: true,
  wizardGroups: [], // main flow group types
  wizardNodes: [],
  wizardEdges: [],
  disabledScenes: [],
  startTitle: "",
  startDescription: "",
  skipStartStep: false,
};

export const defaultWizardSection = { // not used
  id: 0,
  order: 0,
  parentGroupId: 0,
  customDisplayName: "",
  groupName: "",
  enabled: true,
  disabledFeaturesIds: [],
};

export const defaultWizardGroup = {
  id: "1",
  nodeType: WIZARD_GROUP_TYPES.group,
  groupName: "",
  enabled: true,
  title: "",
  description: "",
  scopeImageUrl: "",
  customDisplayName: "",
  featuresExcluded: [],
  featuresIncluded: [],
  useIncluded: false,
  filtersExcluded: [],
  productCartTitle: "",
  productCartDescription: "",
  uploadedImageUrl: "",
  noAvailableFilters: false,
  notRequired: false,
  leadStep: "Project",
  viewType: 3, // 1, 2, 3, 4
  visibleInVisualizers: [],
};

export const defaultWizardNode = {
  id: "1",
  type: "wizardNode",
  position: { x: -100, y: 100 },
  style: {
    background: 'none',
    padding: 0,
    border: 'none',
    width: 300,
    height: 140
  }
};

export const defaultWizardStep = { // not used
  id: 0,
  order: 0,
  parentSectionId: 0,
  filterName: "",
  filterId: "",
  title: "",
  description: "",
  featuresExcluded: [],
  featuresIncluded: [],
  useIncluded: false,
};

export const wizardStepInterface = { // not used
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
  parentSectionId: PropTypes.number.isRequired,
  filterName: PropTypes.string.isRequired,
  filterId: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  featuresExcluded: PropTypes.array,
  featuresIncluded: PropTypes.array,
  useIncluded: PropTypes.bool,
}

export const wizardSectionInterface = { // not used
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
  parentGroupId: PropTypes.number.isRequired,
  groupName: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
};

export const wizardGroupInterface = {
  id: PropTypes.string.isRequired,
  nodeType: PropTypes.oneOf(Object.keys(WIZARD_GROUP_TYPES)).isRequired,
  groupName: PropTypes.string.isRequired,
  filterGroupId: PropTypes.number,
  scopeImageUrl: PropTypes.string,
  customDisplayName: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  featuresExcluded: PropTypes.array,
  featuresIncluded: PropTypes.array,
  useIncluded: PropTypes.bool,
  filtersExcluded: PropTypes.array,
  productCartTitle: PropTypes.string,
  productCartDescription: PropTypes.string,
  uploadedImageUrl: PropTypes.string,
  noAvailableFilters: PropTypes.bool,
  notRequired: PropTypes.bool,
  label: PropTypes.string,
  wizardGroupIcon: PropTypes.string,
  hideInCartAndReceipt: PropTypes.bool,
  skipProductInfo: PropTypes.bool,
  hidePriceNoCart: PropTypes.bool,
  skipLockDontApply: PropTypes.bool,
  dontMatchFeaturesBySku: PropTypes.bool,
  leadStep: PropTypes.string,
  inputFields: PropTypes.array,
  separateSqftLabel: PropTypes.bool,
  headerTitle: PropTypes.string,
  headerSubTitle: PropTypes.string,
  viewType: PropTypes.number,
  visibleInVisualizers: PropTypes.array,
  hideForCustomers: PropTypes.bool, // eye ball, same as project scope logic
  clickOnLogic: PropTypes.object, // {enabled: false, groupName: "", feature: {}}
};

export const wizardNodeInterface = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  position: PropTypes.object.isRequired,
  style: PropTypes.object,
  data: PropTypes.shape({
    wizardGroup: PropTypes.shape(wizardGroupInterface)
  }),
};

export const wizardEdgeInterface = {
  id: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export const wizardItemInterface = {
  id: PropTypes.number,
  uniqueHashId: PropTypes.string, // is used for clone comparing
  visualizer: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  customImageUrl: PropTypes.string,
  uploadedImageUrl: PropTypes.string,
  enabled: PropTypes.bool,
  selected: PropTypes.bool,
  // wizardSteps: PropTypes.arrayOf(PropTypes.shape(wizardStepInterface)),
  // wizardSections: PropTypes.arrayOf(PropTypes.shape(wizardSectionInterface)),
  wizardGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)),
  wizardNodes: PropTypes.arrayOf(PropTypes.shape(wizardNodeInterface)),
  wizardEdges: PropTypes.arrayOf(PropTypes.shape(wizardEdgeInterface)),
  disabledScenes: PropTypes.arrayOf(PropTypes.number),
  startTitle: PropTypes.string,
  startDescription: PropTypes.string,
  skipIntro: PropTypes.bool,
  hideItems: PropTypes.bool,
  hideContext: PropTypes.bool,
  hideInMenu: PropTypes.bool,
  openWizardOnClick: PropTypes.bool,
};

export const wizardExcludedFeatureInterface = {
  sku: PropTypes.string,
  name: PropTypes.string,
  sharedFeatureName: PropTypes.string,
  featureDefinitionId: PropTypes.number
};
